import { render, staticRenderFns } from "./OutputPublicationBias.vue?vue&type=template&id=75fcc256&scoped=true"
import script from "./OutputPublicationBias.vue?vue&type=script&lang=js"
export * from "./OutputPublicationBias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fcc256",
  null
  
)

export default component.exports